import { FilterListOutlined } from "@mui/icons-material";
import {
  Badge,
  Box,
  Button,
  ClickAwayListener,
  Popper,
  useTheme,
} from "@mui/material";
import { DashboardFilterData, Profile } from "aint-types";
import React from "react";

import { FilterDialog } from "./filter-dialog";

export type DashboardTitleCardSlotsProps = {
  filterData: DashboardFilterData;
  userProfile?: Profile;
  handleFilterChange: (
    event: React.ChangeEvent<HTMLInputElement> | string,
    trigger: string
  ) => void;
  clearAllFilters: () => void;
  filterOptions?: {
    oeProjects?: string[];
    functions?: string[];
    LoBs?: string[];
    programs?: string[];
    enablers?: string[];
    regions?: string[];
    implementationPrograms?: string[];
  };
};

export const DashboardTitleCardSlots = ({
  /** currently selected options  */
  filterData,
  userProfile,
  clearAllFilters,
  handleFilterChange,
  filterOptions,
}: DashboardTitleCardSlotsProps) => {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const [open, setOpen] = React.useState(false);
  const clickAwayHandler = () => {
    setOpen(false);
  };
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-start",
        gap: 2,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          "&:hover": {
            backgroundColor: "#FCFCFC",
          },
        }}
      >
        <Box
          sx={{
            color: theme.palette.primary.main,
            marginRight: 1.5,
            cursor: "pointer",
            verticalAlign: "middle",
            borderRadius: "2px",

            height: "30px",
            width: "30px",
            border: "1.5px solid",
            borderColor: theme.palette.primary.main,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
          onClick={(e) => {
            setOpen(true);
            setAnchorEl(e.currentTarget);
          }}
        >
          <Badge
            variant="dot"
            invisible={!hasNonEmptyField(filterData)}
            sx={{
              "& .MuiBadge-dot": {
                backgroundColor: "primary.main",
              },
            }}
          >
            <FilterListOutlined />
          </Badge>
        </Box>
      </Box>
      {open && (
        <ClickAwayListener
          onClickAway={clickAwayHandler}
          mouseEvent={"onMouseUp"}
        >
          <Popper
            open={open}
            anchorEl={anchorEl}
            placement="bottom-start"
            sx={{
              backgroundColor: "background.paper",
              borderColor: theme.palette.primary.main,
              boxShadow: "0px 0px 5px grey",
              borderRadius: 5,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              p: 1,
              maxHeight: "80vh",
              overflow: "auto",
            }}
          >
            <Box>
              <FilterDialog
                onClick={() => {
                  setOpen(false);
                }}
                handleChange={handleFilterChange}
                filterData={filterData}
                userProfile={userProfile}
                filterOptions={filterOptions}
              />
              <Button
                onClick={clearAllFilters}
                sx={{
                  border: "1px solid",
                  padding: "4px 16px",
                  borderCollapse: theme.palette.primary.dark,
                  borderRadius: "4px",
                  color: theme.palette.primary.main,
                  width: "300px",
                  height: "56px",
                }}
              >
                Clear All
              </Button>
            </Box>
          </Popper>
        </ClickAwayListener>
      )}
    </Box>
  );
};

function hasNonEmptyField(filters: DashboardFilterData): boolean {
  return Object.values(filters).some(
    (field) => Array.isArray(field) && field.length > 0
  );
}
